import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import "./AddSubDepartment.css";
import { Apiurl, GetToken } from "../../../Utils/utils";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Header from "../../../Components/Dashboard/Header/Header";
import { toast } from "react-toastify";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Modal } from "react-bootstrap";

const SubDepartment = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [subDeptName, setSubDeptName] = useState("");
  const [subDepartments, setSubDepartments] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingName, setEditingName] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const token = GetToken();

  const getDepartments = useCallback(async () => {
    try {
      const response = await axios.get(`${Apiurl()}/Admin/GetDepartments`, {
        headers: { authorization: `Bearer ${token}` },
      });

      let deptData = response?.data?.data;
      if (typeof deptData === "string") deptData = JSON.parse(deptData);
      if (!Array.isArray(deptData)) deptData = [];

      setDepartments(deptData);
    } catch (error) {
      setDepartments([]);
    }
  }, [token]);

  const getSubDepartments = async (departmentId) => {
    if (!departmentId) {
      setSubDepartments([]);
      return;
    }
    setLoading(true);
    try {
      const payloadObj = { DepartmentId: Number(departmentId) };
      const response = await axios.post(
        `${Apiurl()}/Admin/GetDesignations`,
        { Data: JSON.stringify(payloadObj) },
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      let subDeptData = response?.data?.data;
      if (typeof subDeptData === "string") {
        try {
          subDeptData = JSON.parse(subDeptData);
        } catch (e) {
          subDeptData = [];
        }
      }
      if (!Array.isArray(subDeptData)) {
        subDeptData = subDeptData ? [subDeptData] : [];
      }

      const normalizedData = subDeptData.map((item) => ({
        ...item,
        Id: item?.Id ?? item?.DesignationId ?? item?.id ?? null,
      }));

      setSubDepartments(normalizedData);
    } catch (error) {
      setSubDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshSubDepartments = async () => {
    if (!selectedDept) return;

    await getSubDepartments(selectedDept);
  };

  const saveSubDepartment = async (e) => {
    e.preventDefault();

    if (!selectedDept) {
      toast.error("Please select a department first.");
      return;
    }
    if (!subDeptName.trim()) {
      toast.error("Please enter a Designation name.");
      return;
    }

    setSaving(true);

    const payloadObj = {
      DepartmentId: Number(selectedDept),
      DesignationName: subDeptName.trim(),
    };
    try {
      const response = await axios.post(
        `${Apiurl()}/Admin/SaveDesignation`,
        { Data: JSON.stringify(payloadObj) },
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(
          response?.data?.message || "Designation saved successfully!"
        );

        setSubDeptName("");

        await getSubDepartments(selectedDept);
      } else {
        toast.error(response?.data?.message || "Failed to save Designation");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save Designation");
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditingName(
      subDepartments[index]?.DesignationName ||
        subDepartments[index]?.Name ||
        ""
    );
  };

  const handleUpdate = async (index) => {
    if (!editingName.trim()) {
      toast.error("Designation name cannot be empty.");
      return;
    }

    const subDeptToUpdate = subDepartments[index];
    const subDeptId =
      subDeptToUpdate?.DesignationId ||
      subDeptToUpdate?.Id ||
      subDeptToUpdate?.id;

    if (!subDeptId) {
      toast.error("Designation ID not found. Please refresh and try again.");
      return;
    }

    setSaving(true);
    const payloadObj = {
      Id: subDeptId,
      DepartmentId: Number(selectedDept),
      DesignationName: editingName.trim(),
    };

    try {
      const response = await axios.post(
        `${Apiurl()}/Admin/SaveDesignation`,
        { data: JSON.stringify(payloadObj) },
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(
          response?.data?.message || "Designation updated successfully!"
        );

        setEditingIndex(null);
        setEditingName("");

        await refreshSubDepartments();
      } else {
        toast.error(response?.data?.message || "Failed to update Designation");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to update Designation"
      );
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (index) => {
    const subDeptToDelete = subDepartments[index];
    const subDeptId =
      subDeptToDelete?.DesignationId ||
      subDeptToDelete?.Id ||
      subDeptToDelete?.id;

    if (!subDeptId) {
      toast.error("Designation ID not found. Please refresh and try again.");
      return;
    }

    setSaving(true);
    const payloadObj = { Id: subDeptId };

    try {
      const response = await axios.post(
        `${Apiurl()}/Admin/DeleteDesignation`,
        { Data: JSON.stringify(payloadObj) },
        {
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(
          response?.data?.message || "Designation deleted successfully!"
        );

        await refreshSubDepartments();

        if (editingIndex === index) {
          setEditingIndex(null);
          setEditingName("");
        }
      } else {
        toast.error(response?.data?.message || "Failed to delete Designation");
      }
    } catch (error) {
      if (error?.code === "ERR_NETWORK") {
        toast.error("Network error. Please check your connection and try again.");
      } else {
        toast.error(
          error?.response?.data?.message || "Failed to delete Designation"
        );
      }
    } finally {
      setSaving(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingName("");
  };

  const handleDepartmentChange = (e) => {
    const deptId = e.target.value;
    setSelectedDept(deptId);
    setSubDeptName("");
    setEditingIndex(null);
    setEditingName("");

    if (deptId) {
      getSubDepartments(deptId);
    } else {
      setSubDepartments([]);
    }
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  useEffect(() => {
    getDepartments();
  }, [getDepartments]);

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page-annoucement"
              : "main-container-of-all-employees-page-annoucement-new"
          }
        >
          <div className="admin-page-content">
            <div className="subdept-header-container">
              <div className="all-employee-text-annoucement">
                <h4>Designation</h4>
              </div>
              <div className="all-employees-directory-annoucement">
                <div className="home-icon-header-annoucement">
                  <BiHomeAlt className="home-icon-header-annoucement" />
                </div>
                <div className="arrow-icon-header-annoucement">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-header-annoucement">
                  <p>Dashboard</p>
                </div>
                <div className="arrow-icon-header-profile">
                  <MdKeyboardArrowRight />
                </div>
                <div className="all-employee-text-header-annoucement">
                  <p>Add Designation</p>
                </div>
              </div>
            </div>

            <div className="outer-div-of-username-password-annoucement">
              <div className="security-annoucement">
                <h5>Manage Designation</h5>
              </div>

              <div className="username-password-announcement">
                <div className="row">
                  <div className="col-md-6 username-content-annoucement">
                    <div className="flash-floating-annoucement">
                      <label>Select Department</label>
                      <select
                        className="form-control"
                        value={selectedDept}
                        onChange={handleDepartmentChange}
                      >
                        <option value="">-- Select Department --</option>
                        {departments.map((dept) => (
                          <option key={dept.Id} value={dept.Id}>
                            {dept.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {selectedDept && (
                    <div className="col-md-6 username-content-annoucement">
                      <div className="flash-floating-annoucement">
                        <label>Designation Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={subDeptName}
                          onChange={(e) => setSubDeptName(e.target.value)}
                          placeholder="Enter Designation"
                        />
                      </div>
                    </div>
                  )}
                </div>

                {selectedDept && (
                  <div className="save-button-in-setting-annoucement">
                    <button
                      className="save-button-in-setting-annoucement-button-one"
                      onClick={saveSubDepartment}
                      disabled={saving}
                    >
                      {saving ? "Saving..." : "Save"}
                    </button>
                    <button
                      className="save-button-in-setting-annoucement-button-two"
                      onClick={() => setSubDeptName("")}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>

              {selectedDept && (
                <div className="department-table-container">
                  <h3 style={{ textAlign: "center" }}>Designation List</h3>
                  {loading ? (
                    <div style={{ padding: "20px", textAlign: "center" }}>
                      Loading Designation...
                    </div>
                  ) : (
                    <div className="subdept-table-wrapper">
                      <table className="subdept-table">
                        <thead>
                          <tr>
                            <th>Id No.</th>
                            <th>Designation Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {subDepartments.length > 0 ? (
                            subDepartments.map((subDept, index) => (
                              <tr
                                key={
                                  subDept?.Id || subDept?.DesignationId || index
                                }
                              >
                                <td>{index + 1}</td>
                                <td>
                                  {editingIndex === index ? (
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={editingName}
                                      onChange={(e) =>
                                        setEditingName(e.target.value)
                                      }
                                    />
                                  ) : (
                                    subDept?.DesignationName ||
                                    subDept?.Name ||
                                    "N/A"
                                  )}
                                </td>
                                <td>
                                  {editingIndex === index ? (
                                    <>
                                      <button
                                        className="btn btn-success btn-sm me-2"
                                        onClick={() => handleUpdate(index)}
                                        disabled={saving}
                                      >
                                        Update
                                      </button>
                                      <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={handleCancelEdit}
                                      >
                                        Cancel
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="btn btn-primary btn-sm me-2"
                                        onClick={() => handleEdit(index)}
                                      >
                                        Edit
                                      </button>
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => {
                                          setDeleteIndex(index);
                                          setShowDeleteModal(true);
                                        }}
                                        disabled={saving}
                                      >
                                        Delete
                                      </button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" style={{ textAlign: "center" }}>
                                No Designation found for this department
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeleteIndex(null);
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to delete this Designation?</p>
          <strong>
            {deleteIndex !== null &&
              (subDepartments[deleteIndex]?.DesignationName ||
                subDepartments[deleteIndex]?.Name)}
          </strong>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteIndex(null);
            }}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={async () => {
              await handleDelete(deleteIndex);
              setShowDeleteModal(false);
              setDeleteIndex(null);
            }}
            disabled={saving}
          >
            {saving ? "Deleting..." : "Yes, Delete"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SubDepartment;